// We only need to import the modules necessary for initial render
// When you add a first route be sure to remove the comment from the lines below.

import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
// import rootStore from 'Store/createStore'
// import asyncComponent from 'Hoc/AsyncComponent'
import LazyComponent from 'Hoc/LazyComponent'

const Homepage = lazy(() => import(/* webpackChunkName: "Homepage" */ './Homepage'))
const Login = lazy(() => import(/* webpackChunkName: "Login" */ './Login'))
const Registration = lazy(() => import(/* webpackChunkName: "Registration" */ './Registration'))
const RecoveryPassword = lazy(() => import(/* webpackChunkName: "RecoveryPassword" */ './RecoveryPassword'))
const Profile = lazy(() => import(/* webpackChunkName: "Profile" */ './Profile'))
const CompanyData = lazy(() => import(/* webpackChunkName: "CompanyData" */ './CompanyData'))
const PersonalData = lazy(() => import(/* webpackChunkName: "PersonalData" */ './PersonalData'))
const Documents = lazy(() => import(/* webpackChunkName: "Documents" */ './Documents'))
const Services = lazy(() => import(/* webpackChunkName: "Services" */ './Services'))
const Courtesy = lazy(() => import(/* webpackChunkName: "Courtesy" */ './Courtesy'))
const PayByLink = lazy(() => import(/* webpackChunkName: "PayByLink" */ './PayByLink'))
const SecondaryUsers = lazy(() => import(/* webpackChunkName: "SecondaryUsers" */ './SecondaryUsers'))
const CallUs = lazy(() => import(/* webpackChunkName: "CallUs" */ './CallUs'))
const ContactUs = lazy(() => import(/* webpackChunkName: "ContactUs" */ './ContactUs'))
const Support = lazy(() => import(/* webpackChunkName: "Support" */ './Support'))
const LoginHandler = lazy(() => import(/* webpackChunkName: "LoginHandler" */ './LoginHandler'))
const Xpay = lazy(() => import(/* webpackChunkName: "Xpay" */ './Xpay'))
const XpayHotel = lazy(() => import(/* webpackChunkName: "XpayHotel" */ './XpayHotel'))
const XpayRistorante = lazy(() => import(/* webpackChunkName: "XpayRistorante" */ './XpayRistorante'))
const RubiconeGold = lazy(() => import(/* webpackChunkName: "RubiconeGold" */ './RubiconeGold'))
const NexiExclusive = lazy(() => import(/* webpackChunkName: "NexiExclusive" */ './NexiExclusive'))
const VetrinaDigitale = lazy(() => import(/* webpackChunkName: "VetrinaDigitale" */ './VetrinaDigitale'))
const Micropagamenti = lazy(() => import(/* webpackChunkName: "Micropagamenti" */ './Micropagamenti'))
const HeyLight = lazy(() => import(/* webpackChunkName: "HeyLight" */ './HeyLight'))
const Dcc = lazy(() => import(/* webpackChunkName: "Dcc" */ './Dcc'))
const Amex = lazy(() => import(/* webpackChunkName: "Amex" */ './Amex'))
const AmexHotel = lazy(() => import(/* webpackChunkName: "AmexHotel" */ './AmexHotel'))
const BuoniPasto = lazy(() => import(/* webpackChunkName: "BuoniPasto" */ './BuoniPasto'))
const PayByLinkService = lazy(() => import(/* webpackChunkName: "PayByLinkService" */ './PayByLinkService'))
const AddPos = lazy(() => import(/* webpackChunkName: "AddPos" */ './AddPos'))
const ChangePos = lazy(() => import(/* webpackChunkName: "ChangePos" */ './ChangePos'))
const Comunications = lazy(() => import(/* webpackChunkName: "Comunications" */ './Comunications'))
const LoginNb = lazy(() => import(/* webpackChunkName: "LoginNb" */ './LoginNb'))
const Results = lazy(() => import(/* webpackChunkName: "Results" */ './Results'))
const RegistrationNb = lazy(() => import(/* webpackChunkName: "RegistrationNb" */ './RegistrationNb'))
const Transactions = lazy(() => import(/* webpackChunkName: "Transactions" */ './Transactions'))
const LoginApp = lazy(() => import(/* webpackChunkName: "LoginApp" */ './LoginApp'))
const TriggerTimeline = lazy(() => import(/* webpackChunkName: "TriggerTimeline" */ './TriggerTimeline'))
const KitStart = lazy(() => import(/* webpackChunkName: "KitStart" */ './KitStart'))
const Wcf = lazy(() => import(/* webpackChunkName: "Wcf" */ './Wcf'))
const Costs = lazy(() => import(/* webpackChunkName: "Costs" */ './Costs'))
const Dispute = lazy(() => import(/* webpackChunkName: "Dispute" */ './Dispute'))
const NexiClub = lazy(() => import(/* webpackChunkName: "NexiClub" */ './NexiClub'))
const Pci = lazy(() => import(/* webpackChunkName: "Pci" */ './Pci'))
const ApiCloudSmartPos = lazy(() => import(/* webpackChunkName: "ApiCloudSmartPos" */ './ApiCloudSmartPos'))
const Aml = lazy(() => import(/* webpackChunkName: "Aml" */ './Aml'))
const SoftPos = lazy(() => import(/* webpackChunkName: "SoftPos" */ './SoftPos'))
const DeactivateTerminal = lazy(() => import(/* webpackChunkName: "DeactivateTerminal" */ './DeactivateTerminal'))
const SupportPreLogin = lazy(() => import(/* webpackChunkName: "SupportPreLogin" */ './SupportPreLogin'))
const MobileSso = lazy(() => import(/* webpackChunkName: "MobileSso" */ './MobileSso'))
const PagoPa = lazy(() => import(/* webpackChunkName: "PagoPa" */ './PagoPa'))
const LoginMos = lazy(() => import(/* webpackChunkName: "LoginMos" */ './LoginMos'))
const BackupPos = lazy(() => import(/* webpackChunkName: "BackupPos" */ './BackupPos'))
const SiteMap = lazy(() => import(/* webpackChunkName: "SiteMap" */ './SiteMap'))
const OldNpg = lazy(() => import(/* webpackChunkName: "OldNpg" */ './OldNpg'))
const ProfileMenu = lazy(() => import(/* webpackChunkName: "ProfileMenu" */ './ProfileMenu'))
const Menu = lazy(() => import(/* webpackChunkName: "Menu" */ './Menu'))
const Report = lazy(() => import(/* webpackChunkName: "Report" */ './Report'))
const Impersonification = lazy(() => import(/* webpackChunkName: "Impersonification" */ './Impersonification'))
const LoginMosApp = lazy(() => import(/* webpackChunkName: "LoginMosApp" */ './LoginMosApp'))
const MosSsoMobile = lazy(() => import(/* webpackChunkName: "MosSsoMobile" */ './MosSsoMobile'))
const DisputeUci = lazy(() => import(/* webpackChunkName: "DisputeUci" */ './DisputeUci'))
const ShortLink = lazy(() => import(/* webpackChunkName: "ShortLink" */ './ShortLink'))
// @generator routes:import

export const Components = {
  // @generator routes:component export
  DisputeUci,
  ShortLink,
  Menu,
  Report,
  ProfileMenu,
  MosSsoMobile,
  LoginMosApp,
  Impersonification,
  OldNpg,
  SiteMap,
  BackupPos,
  LoginMos,
  PagoPa,
  MobileSso,
  SupportPreLogin,
  DeactivateTerminal,
  SoftPos,
  Aml,
  ApiCloudSmartPos,
  Pci,
  NexiClub,
  Dispute,
  Costs,
  Wcf,
  KitStart,
  TriggerTimeline,
  Transactions,
  RegistrationNb,
  LoginApp,
  Results,
  LoginNb,
  Comunications,
  ChangePos,
  AddPos,
  PayByLinkService,
  BuoniPasto,
  AmexHotel,
  Amex,
  Dcc,
  HeyLight,
  Micropagamenti,
  VetrinaDigitale,
  NexiExclusive,
  RubiconeGold,
  Xpay,
  XpayHotel,
  XpayRistorante,
  Support,
  ContactUs,
  CallUs,
  LoginHandler,
  SecondaryUsers,
  PayByLink,
  Courtesy,
  Services,
  Documents,
  PersonalData,
  Profile,
  RecoveryPassword,
  Registration,
  Login,
  Homepage,
  CompanyData
}

export const createAuthRoutes = () => ({
  routes: [
    {
      key: 'Homepage',
      component: (props) => (
        <Route
          path='/*'
          key='Homepage'
          element={<LazyComponent componentName='Homepage' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'ProfileMenu',
      component: (props) => (
        <Route
          path='/profile-menu/*'
          key='ProfileMenu'
          element={<LazyComponent componentName='ProfileMenu' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Menu',
      component: (props) => (
        <Route
          path='/menu/*'
          key='Menu'
          element={<LazyComponent componentName='Menu' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Report',
      component: (props) => (
        <Route
          path='/report/*'
          key='Report'
          element={<LazyComponent componentName='Report' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Profile',
      component: (props) => (
        <Route
          path='/profile/*'
          key='Profile'
          element={<LazyComponent componentName='Profile' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'CompanyData',
      component: (props) => (
        <Route
          path='/profile/company-data/*'
          key='CompanyData'
          element={<LazyComponent componentName='CompanyData' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PersonalData',
      component: (props) => (
        <Route
          path='/profile/personal-data/*'
          key='PersonalData'
          element={<LazyComponent componentName='PersonalData' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Documents',
      component: (props) => (
        <Route
          path='/documents/*'
          key='Documents'
          element={<LazyComponent componentName='Documents' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PayByLink',
      component: (props) => (
        <Route
          path='/pay-by-link/*'
          key='PayByLink'
          element={<LazyComponent componentName='PayByLink' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'SecondaryUsers',
      component: (props) => (
        <Route
          path='/profile/secondary-users/*'
          key='SecondaryUsers'
          element={<LazyComponent componentName='SecondaryUsers' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'CallUs',
      component: (props) => (
        <Route
          path='/call-us/*'
          key='CallUs'
          element={<LazyComponent componentName='CallUs' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'ContactUs',
      component: (props) => (
        <Route
          path='/contact-us/*'
          key='ContactUs'
          element={<LazyComponent componentName='ContactUs' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Support',
      component: (props) => (
        <Route
          path='/support/*'
          key='Support'
          element={<LazyComponent componentName='Support' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'LoginHandler',
      component: (props) => (
        <Route
          excludeProfiling
          path='/login-handler/*'
          key='LoginHandler'
          element={<LazyComponent componentName='LoginHandler' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Xpay',
      component: (props) => (
        <Route
          path='/services/xpay/*'
          key='Xpay'
          element={<LazyComponent componentName='Xpay' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'XpayHotel',
      component: (props) => (
        <Route
          path='/services/xpay-hotel/*'
          key='XpayHotel'
          element={<LazyComponent componentName='XpayHotel' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'XpayRistorante',
      component: (props) => (
        <Route
          path='/services/xpay-ristorante/*'
          key='XpayRistorante'
          element={<LazyComponent componentName='XpayRistorante' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'RubiconeGold',
      component: (props) => (
        <Route
          path='/services/rubicone/*'
          key='RubiconeGold'
          element={<LazyComponent componentName='RubiconeGold' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'NexiExclusive',
      component: (props) => (
        <Route
          path='/services/nexi-exclusive/*'
          key='NexiExclusive'
          element={<LazyComponent componentName='NexiExclusive' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'VetrinaDigitale',
      component: (props) => (
        <Route
          path='/services/vetrina-digitale/*'
          key='VetrinaDigitale'
          element={<LazyComponent componentName='VetrinaDigitale' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Micropagamenti',
      component: (props) => (
        <Route
          path='/services/micropagamenti/*'
          key='Micropagamenti'
          element={<LazyComponent componentName='Micropagamenti' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'HeyLight',
      component: (props) => (
        <Route
          path='/services/heylight/*'
          key='HeyLight'
          element={<LazyComponent componentName='HeyLight' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Dcc',
      component: (props) => (
        <Route
          path='/services/Dcc/*'
          key='Dcc'
          element={<LazyComponent componentName='Dcc' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Amex',
      component: (props) => (
        <Route
          path='/services/amex/*'
          key='Amex'
          element={<LazyComponent componentName='Amex' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'AmexHotel',
      component: (props) => (
        <Route
          path='/services/amex-hotel/*'
          key='AmexHotel'
          element={<LazyComponent componentName='AmexHotel' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'BuoniPasto',
      component: (props) => (
        <Route
          path='/services/buoni-pasto/*'
          key='BuoniPasto'
          element={<LazyComponent componentName='BuoniPasto' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PayByLinkService',
      component: (props) => (
        <Route
          path='/services/pay-by-link/*'
          key='PayByLinkService'
          element={<LazyComponent componentName='PayByLinkService' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'AddPos',
      component: (props) => (
        <Route
          path='/services/add-pos/*'
          key='AddPos'
          element={<LazyComponent componentName='AddPos' {...props} hasReducer hasSaga />}
        />
      )
    },
    {
      key: 'ChangePos',
      component: (props) => (
        <Route
          path='/services/change-pos/*'
          key='ChangePos'
          element={<LazyComponent componentName='ChangePos' {...props} hasReducer hasSaga />}
        />
      )
    },
    {
      key: 'Wcf',
      component: (props) => (
        <Route
          path='/services/wcf/*'
          key='Wcf'
          element={<LazyComponent componentName='Wcf' {...props} hasReducer hasSaga />}
        />
      )
    },
    {
      key: 'Services',
      component: (props) => (
        <Route
          path='/services/*'
          key='Services'
          element={<LazyComponent componentName='Services' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Comunications',
      component: (props) => (
        <Route
          path='profile/comunications/*'
          key='Comunications'
          element={<LazyComponent componentName='Comunications' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Results',
      component: (props) => (
        <Route
          path='/results/*'
          key='Results'
          element={<LazyComponent componentName='Results' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Transactions',
      component: (props) => (
        <Route
          path='/transactions/*'
          key='Transactions'
          element={<LazyComponent componentName='Transactions' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'TriggerTimeline',
      component: (props) => (
        <Route
          path='/triggertimeline/*'
          key='TriggerTimeline'
          element={<LazyComponent componentName='TriggerTimeline' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'KitStart',
      component: (props) => (
        <Route
          path='/kitstart/*'
          key='KitStart'
          element={<LazyComponent componentName='KitStart' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Costs',
      component: (props) => (
        <Route
          path='/costs/*'
          key='Costs'
          element={<LazyComponent componentName='Costs' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Dispute',
      component: (props) => (
        <Route
          path='/dispute/*'
          key='Dispute'
          element={<LazyComponent componentName='Dispute' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'DisputeUci',
      component: (props) => (
        <Route
          path='/dispute-uci/*'
          key='DisputeUci'
          element={<LazyComponent componentName='DisputeUci' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'NexiClub',
      component: (props) => (
        <Route
          path='/nexiclub/*'
          key='NexiClub'
          element={<LazyComponent componentName='NexiClub' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Pci',
      component: (props) => (
        <Route path='/pci/*' key='Pci' element={<LazyComponent componentName='Pci' {...props} hasSaga hasReducer />} />
      )
    },
    {
      key: 'ApiCloudSmartPos',
      component: (props) => (
        <Route
          path='/api-cloud/*'
          key='ApiCloudSmartPos'
          element={<LazyComponent componentName='ApiCloudSmartPos' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Aml',
      component: (props) => (
        <Route path='/aml/*' key='Aml' element={<LazyComponent componentName='Aml' {...props} hasSaga hasReducer />} />
      )
    },
    {
      key: 'SoftPos',
      component: (props) => (
        <Route
          path='/softpos/*'
          key='SoftPos'
          element={<LazyComponent componentName='SoftPos' {...props} hasReducer hasSaga />}
        />
      )
    },
    {
      key: 'DeactivateTerminal',
      component: (props) => (
        <Route
          path='/deactivate-terminal/*'
          key='DeactivateTerminal'
          element={<LazyComponent componentName='DeactivateTerminal' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'PagoPa',
      component: (props) => (
        <Route path='/pagopa/*' key='PagoPa' element={<LazyComponent componentName='PagoPa' hasSaga hasReducer {...props} />} />
      )
    },
    {
      key: 'BackupPos',
      component: (props) => (
        <Route
          path='/backup-pos/*'
          key='BackupPos'
          element={<LazyComponent componentName='BackupPos' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'SiteMap',
      component: (props) => (
        <Route
          path='/sitemap/*'
          key='SiteMap'
          element={<LazyComponent componentName='SiteMap' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'MosSsoMobile',
      component: (props) => (
        <Route
          path='/mos-sso-mobile/*'
          key='MosSsoMobile'
          element={<LazyComponent componentName='MosSsoMobile' {...props} hasSaga hasReducer />}
        />
      )
    }
  ]
})

// These routes don't need the user to be logged in.

export const createUnauthRoutes = () => ({
  routes: [
    {
      key: 'Login',
      component: (props) => (
        <Route path='/login/*' key='Login' element={<LazyComponent componentName='Login' {...props} />} />
      )
    },
    {
      key: 'LoginNb',
      component: (props) => (
        <Route path={`${process.env.PATH_LOGIN}/*`} key='LoginNb' element={<LazyComponent componentName='LoginNb' {...props} />} />
      )
    },
    {
      key: 'LoginApp',
      component: (props) => (
        <Route
          path='/login-app/*'
          key='LoginApp'
          element={<LazyComponent componentName='LoginApp' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Registration',
      component: (props) => (
        <Route
          path='/registration/*'
          key='Registration'
          element={<LazyComponent componentName='Registration' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'RegistrationNb',
      component: (props) => (
        <Route
          path='/registration-nb/*'
          key='RegistrationNb'
          element={<LazyComponent componentName='RegistrationNb' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'RecoveryPassword',
      component: (props) => (
        <Route
          path='/recovery-credential/*'
          key='RecoveryPassword'
          element={<LazyComponent componentName='RecoveryPassword' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'Courtesy',
      component: (props) => (
        <Route path='/courtesy/*' key='Courtesy' element={<LazyComponent componentName='Courtesy' {...props} />} />
      )
    },
    {
      key: 'SupportPreLogin',
      component: (props) => (
        <Route
          path='/support-pre-login/*'
          key='SupportPreLogin'
          element={<LazyComponent componentName='SupportPreLogin' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'MobileSso',
      component: (props) => (
        <Route
          path='/mobilesso/*'
          key='MobileSso'
          element={<LazyComponent componentName='MobileSso' {...props} hasSaga hasReducer />}
        />
      )
    },
    {
      key: 'LoginMos',
      component: (props) => (
        <Route path='/login-mos/*' key='LoginMos' element={<LazyComponent componentName='LoginMos' {...props} />} />
      )
    },
    {
      key: 'OldNpg',
      component: (props) => (
        <Route
          path='/oldnpg/*' key='OldNpg' element={
            <LazyComponent
              componentName='OldNpg' {...props}
            />
          }
        />
      )
    }, {
      key: 'Impersonification',
      component: (props) => (
        <Route
          path='/impersonification/*' key='Impersonification' element={
            <LazyComponent
              componentName='Impersonification' {...props}
              hasSaga hasReducer
            />
          }
        />
      )
    },
    {
      key: 'LoginMosApp',
      component: (props) => (
        <Route
          path='/login-mos-app/*' key='LoginMosApp' element={
            <LazyComponent
              componentName='LoginMosApp' {...props}
            />
          }
        />
      )
    },
    {
      key: 'ShortLink',
      component: (props) => (
        <Route
          path='/sl/*' key='ShortLink' element={
            <LazyComponent
              componentName='ShortLink' {...props}
              hasSaga hasReducer
            />
          }
        />
      )
    }// @generator routes:define:unauth
  ]
})

export default createAuthRoutes
